module.exports = __webpack_public_path__ + "static/media/onda-login.67e4b25d.png";